import React, { ReactComponentElement } from "react";

import SidebarContentWrapperInner from "./SidebarContentWrapperInner";
import SidebarContentWrapperOuter from "./SidebarContentWrapperOuter";

type Props = {
  children:
    | ReactComponentElement<any, any>
    | ReactComponentElement<any, any>[]
    | any;
  dataTest?: string;
  className?: string;
  hasTabBar?: boolean;
};

export default function SidebarContentWrapper({
  dataTest,
  children,
  className,
  hasTabBar
}: Props) {
  return (
    <SidebarContentWrapperOuter dataTest={dataTest} hasTabBar={hasTabBar}>
      <SidebarContentWrapperInner className={className}>
        {children}
      </SidebarContentWrapperInner>
    </SidebarContentWrapperOuter>
  );
}
